import React from "react";
import { Segment, Divider } from "semantic-ui-react";
import { SemanticContainer, SemanticSegment } from "./styled";

import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import ListarIndicacoesAll from "../../../../components/Admin/Eventos/ListagemIndicacoesAll";

const ListaIndicacoesAll = (props) => {
  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <SemanticContainer>
        <h2>Indicações</h2>
        <Divider />
        <Segment>
          <ListarIndicacoesAll />
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment>
          Grupo Voitto <i class="copyright outline icon"></i>2020
        </SemanticSegment>
      </SemanticContainer>
    </div>
  );
};

export default withRouter(ListaIndicacoesAll);
